import { render, staticRenderFns } from "./CreateExam.vue?vue&type=template&id=9cd78088&scoped=true&"
import script from "./CreateExam.vue?vue&type=script&lang=js&"
export * from "./CreateExam.vue?vue&type=script&lang=js&"
import style0 from "./CreateExam.vue?vue&type=style&index=0&id=9cd78088&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9cd78088",
  null
  
)

export default component.exports